import styled from 'styled-components';

export const HeaderContainer = styled.header`
  background-color: var(--bg-header);
  padding: 0.5rem 1rem;
  color: var(--text-bright);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px var(--shadow-light);
  flex-shrink: 0;
  z-index: 100;
  position: relative; /* ✨ 자식 메뉴의 top: 100% 기준점 */
  min-height: 60px;
`;

export const HeaderLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const DesktopActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 1024px) {
    display: none; /* ✨ 모바일/태블릿에선 숨김 */
  }
`;

export const MobileMenuToggle = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.8rem;
  color: var(--text-bright);
  cursor: pointer;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const MobileMenuContainer = styled.div<{ isOpen: boolean }>`
  display: none;
  
  @media (max-width: 1024px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    flex-direction: column;
    background: var(--bg-header);
    padding: 1rem;
    border-top: 1px solid var(--border-color);
    gap: 0.5rem;
    position: absolute;
    top: 100%; /* ✨ 부모 높이에 맞춰 자동으로 붙음 */
    left: 0;
    right: 0;
    z-index: 1000;
    box-shadow: 0 8px 16px rgba(0,0,0,0.3);

    button, .calendar-button {
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        padding: 0.8rem 1rem;
    }
  }
`;